<div class="row m-0 po-body">
    <nav *ngIf="false" class="navbar-primary" id="nav-data">
        <div class="dashboard_logo">
            <a target="_blank">
                <img src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1607238429/truventor/tru-logo.png">
            </a>
        </div>
        <ul class="navbar-primary-menu ">
            <!--<li>-->
            <!--	<a [routerLink]="['/admin/purchase-orders']" routerLinkActive="active">-->
            <!--		<img class="hide-after-active" src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1580135138/DashboardGrey.png" >-->
            <!--		<img class="after-active" src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1580135138/DashboardBlue.png" >-->
            <!--			<span class="nav-label" >Dashboard</span>-->
            <!--		</a>-->
            <!--</li>-->
            <li>
                <a [routerLink]="['/admin/rfq']" routerLinkActive="active">
                    <img class="hide-after-active"
                        src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1579938467/icon-analytics.svg">
                    <img class="after-active"
                        src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1579942042/icon-analytics-after.png">
                    <span class="nav-label">RFQ's</span>
                </a>
            </li>
            <li>
                <a [routerLink]="['/admin/purchase-orders']" routerLinkActive="active">
                    <img class="hide-after-active"
                        src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1580133688/PurchaseOrderGrey.png">
                    <img class="after-active"
                        src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1580133688/PurchaseOrderBlue.png">
                    <span class="nav-label">Purchase&nbsp;Orders</span>
                </a>
            </li>
            <li>
                <a [routerLink]="['/admin/dispatches']" routerLinkActive="active">
                    <img class="hide-after-active"
                        src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1579938467/icon-analytics.svg">
                    <img class="after-active"
                        src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1579942042/icon-analytics-after.png">
                    <span class="nav-label">Dispatches</span>
                </a>
            </li>
            <li>
                <a [routerLink]="['/admin/invoices']" routerLinkActive="active">
                    <img class="hide-after-active"
                        src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1586157090/Invoice_Faded_Color.png">
                    <img class="after-active"
                        src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1586157103/Invoice_color.png">
                    <span class="nav-label">Invoices</span>
                </a>
            </li>
            <li>
                <a [routerLink]="['/admin/update-profile']" routerLinkActive="active">
                    <img class="hide-after-active"
                        src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1580135056/ProfileUpdateGrey.png">
                    <img class="after-active"
                        src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1579942273/dashboard-profile-after.png">
                    <span class="nav-label"> Profile</span>
                </a>
            </li>

            <li>
                <a [routerLink]="['/admin/working-capital']" routerLinkActive="active">
                    <img class="hide-after-active"
                        src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1580135056/ProfileUpdateGrey.png">
                    <img class="after-active"
                        src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1579942273/dashboard-profile-after.png">
                    <span class="nav-label"> Finance</span>
                </a>
            </li>
            <li>
                <a [routerLink]="['/admin/collective-buying']" routerLinkActive="active">
                    <img class="hide-after-active"
                        src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1580135056/ProfileUpdateGrey.png">
                    <img class="after-active"
                        src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1579942273/dashboard-profile-after.png">
                    <span class="nav-label"> Procure</span>
                </a>
            </li>



            <!--<li>-->
            <!--	<a [routerLink]="['/admin/purchase-orders']" routerLinkActive="active">-->
            <!--		<img class="hide-after-active" src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1580135056/ProfileUpdateGrey.png" >-->
            <!--		<img class="after-active" src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1580135056/ProfileUpdateBlue.png" >				-->
            <!--              <span class="nav-label" >Profile</span>-->
            <!--	</a>-->
            <!--</li>-->
        </ul>
    </nav>
    <div *ngIf="false" class="p-0 main-div">
        <nav class="navbar navbar-expand-lg navbar-dark static-top nav-custom">
            <div class="display-contents">
                <a><span class="hide-md-lg open-nav-icon" (click)="openNav()">&#9776;</span>Manufacturing Partner
                    Portal</a>
                <div class="dropdown hide-md-lg">
                    <span class="dropbtn"></span>

                    <div class="dropdown-content">
                        <a>Notifications</a>
                        <a [routerLink]="['/admin/help']">Help</a>
                        <a (click)="logout()" *ngIf="isLoggedIn()">Logout</a>
                    </div>
                </div>

                <div id="mySidenav" class="sidenav hide-md-lg" [ngClass]="{'sidenavfull': opennav == true}">
                    <a href="javascript:void(0)" class="closebtn" (click)="closeNav()">&times;</a>
                    <a (click)="closeNav()" [routerLink]="['/admin/purchase-orders']" routerLinkActive="active">
                        &nbsp;&nbsp;&nbsp;&nbsp;<img class="hide-after-active"
                            src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1580133688/PurchaseOrderGrey.png">
                        &nbsp;&nbsp;&nbsp;&nbsp;<span class="nav-label">Purchase&nbsp;Orders</span>
                    </a>
                    <a (click)="closeNav()" [routerLink]="['/admin/dispatches']" routerLinkActive="active">
                        &nbsp;&nbsp;&nbsp;&nbsp;<img class="hide-after-active"
                            src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1579938467/icon-analytics.svg">
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span class="nav-label">Dispatches</span>
                    </a>
                    <a (click)="closeNav()" [routerLink]="['/admin/invoices/all']" routerLinkActive="active">
                        &nbsp;&nbsp;&nbsp;&nbsp;<img class="hide-after-active"
                            src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1586157090/Invoice_Faded_Color.png">
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span class="nav-label">Invoices</span>
                    </a>
                    <a (click)="closeNav()" [routerLink]="['/admin/update-profile']" routerLinkActive="active">
                        &nbsp;&nbsp;&nbsp;&nbsp;<img class="hide-after-active"
                            src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1580135056/ProfileUpdateGrey.png">
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span class="nav-label"> Profile</span>
                    </a>
                    <a (click)="closeNav()" [routerLink]="['/admin/rfq']" routerLinkActive="active">
                        &nbsp;&nbsp;&nbsp;&nbsp;<img class="hide-after-active"
                            src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1580133688/PurchaseOrderGrey.png">
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span class="nav-label"> RFQ's</span>
                    </a>
                </div>

                <div class="collapse navbar-collapse" id="navbarResponsive">
                    <ul class="navbar-nav ml-auto ">
                        <li class="nav-item">
                            <a class="nav-link center">
                                <img
                                    src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1579935577/notification.png">
                                <p class="no-margin text">Notifications</p>
                                <!--<p class="notification-count">2</p>-->
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link center" [routerLink]="['/admin/help']">
                                <img src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1579936975/info.png">
                                <p class="no-margin text">Help</p>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link center" (click)="logout()" *ngIf="isLoggedIn()">
                                <img class="profile-img"
                                    src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1579937712/profile.png">
                                <p class="no-margin text">Logout</p>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <router-outlet></router-outlet>
    </div>
</div>


<div class="new-branding">
    <div class="new-top-nav">
        <div class="new-side-nav" (mouseover)="showNav = !showNav " (mouseout)="showNav = !showNav">
            <div class="main-menu" [ngClass]="showNav?'expanded-nav':''">
                <ul class="list">
                    <li class="pointer" [routerLink]="['/admin/dashboard']" routerLinkActive="active">
                        <span class="list-icon "><img class="" src="assets/svg/dashboard.svg" alt=""></span><span
                            class="nav-text">Dashboard</span>
                    </li>
                    <div (click)="toggleSubmenu()" *ngIf="isRMS">
                        <li class="pointer" routerLinkActive="active" *ngIf="isRMS">
                            <span class="list-icon order"><img class="" src="assets/svg/order-management.svg"
                                    alt=""></span>
                            <span class="nav-text">Order Management &nbsp;
                                <img class="toggle-icon"
                                    [src]="submenu ? 'assets/svg/arrow up green.svg' : 'assets/svg/arrow down green.svg'"
                                    alt="Toggle arrow icon">
                            </span>
                        </li>
                    </div>
                    <div>
                        <div class="sub-menu" [ngClass]="{'open': submenu && isRMS}">
                            <li class="pointer" [routerLink]="['/admin/rfq/']" routerLinkActive="active">
                                <span class="list-icon">
                                    <span class="order-management">
                                        <img class="" src="assets/svg/enquiry.svg" alt=""></span><span
                                        class="nav-text">Enquiry
                                    </span>
                                </span>
                            </li>

                            <li class="pointer" [routerLink]="['/admin/quotes/']" routerLinkActive="active">
                                <span class="list-icon">
                                    <span class="order-management">
                                        <img class="" src="assets/svg/invoice.svg" alt=""></span><span
                                        class="nav-text">Quotes
                                    </span>
                                </span>
                            </li>

                            <li class="pointer" [routerLink]="['/admin/purchase-orders/']" routerLinkActive="active">
                                <span class="list-icon">
                                    <span class="order-management">
                                        <img class="" src="assets/svg/order-management.svg" alt=""></span><span
                                        class="nav-text">Order
                                    </span>
                                </span>
                            </li>

                            <!-- !!! No longer in new design. Same logo is used for showing quotes now which is nothing but pending PO -->
                            <!-- <li class="pointer" [routerLink]="['/admin/invoices/statistics']" routerLinkActive="active">
                                <span class="list-icon">
                                    <span class="order-management">
                                        <img class="" src="assets/svg/invoice.svg" alt=""></span><span
                                        class="nav-text">Invoice
                                    </span>
                                </span>
                            </li> -->
                        </div>
                    </div>

                    <li class="pointer" [routerLink]="['/admin/inspection']" routerLinkActive="active" *ngIf="isRMS">
                        <span class="list-icon"><img class="" src="assets/svg/inspection-black.svg" alt=""></span><span
                            class="nav-text">Inspection</span>
                    </li>

                    <li class="pointer" [routerLink]="['/admin/shipments']" routerLinkActive="active" *ngIf="isRMS">
                        <span class="list-icon"><img class="" src="assets/svg/shipments.svg" alt=""></span><span
                            class="nav-text">My Shipments</span>
                    </li>

                    <li class="pointer" [routerLink]="['/admin/supplier-invoices']" routerLinkActive="active" *ngIf="isRMS">
                        <span class="list-icon"><img class="" src="assets/svg/supplier_invoices.svg" alt=""></span><span
                            class="nav-text">Supplier Invoices</span>
                    </li>

                    <li class="pointer" [routerLink]="['/admin/collective-buying']" routerLinkActive="active"
                        *ngIf="isRMS">
                        <span class="list-icon"><img class="" src="assets/svg/collective-buying.svg" alt=""></span><span
                            class="nav-text">Collective Buying</span>
                    </li>

                    <li class="pointer" [routerLink]="['/admin/working-capital']" routerLinkActive="active"
                        *ngIf="isRMS">
                        <span class="list-icon"><img class="" src="assets/svg/working-capital.svg" alt=""></span><span
                            class="nav-text">Working Capital</span>
                    </li>

                    <li class="pointer" [routerLink]="['/admin/engage-request']" routerLinkActive="active"
                        *ngIf="isRMS">
                        <span class="list-icon"><img class="" src="assets/svg/machine-on-rent.svg" alt=""></span><span
                            class="nav-text">Engage Request</span>
                    </li>

                    <li class="pointer" [routerLink]="['/admin/supplier-profile']" routerLinkActive="active">
                        <span class="list-icon"><img class="" src="assets/svg/my_website.svg" alt=""></span><span
                            class="nav-text">My Website</span>
                    </li>


                    <li class="pointer" [routerLink]="['/admin/tickets']" routerLinkActive="active" *ngIf="isRMS">
                        <span class="list-icon"><img class="" src="assets/svg/tickets-black.svg" alt=""></span><span
                            class="nav-text">Tickets</span>
                    </li>


                    <!-- !########### DONOT DELETE - TO BE IMPLEMENTED LATER ########################## -->
                    <li *ngIf="false" class="pointer" (click)="navigation()">
                        <span class="list-icon "><img class="" src="assets/svg/dashboard.svg" alt=""></span><span
                            class="nav-text">Control</span>
                    </li>
                    <!-- !########### DONOT DELETE - TO BE IMPLEMENTED LATER ########################## -->


                    <!-- procure changes hide here -->
                    <!-- <div (click)="subprocuremenu = !subprocuremenu">
                        <li class="pointer" routerLinkActive="active">
                            <span class="list-icon order"><img  class="" src="assets/svg/order-management.svg" alt=""></span><span class="nav-text">Procure &nbsp;<img *ngIf="subprocuremenu" style="width: 10px; height: 10px; transition-duration: 0.5s;" src="assets/svg/arrow up green.svg" alt=""><img *ngIf="!subprocuremenu" style="width: 10px; height: 10px; transition-duration: 0.5s;" src="assets/svg/arrow down green.svg" alt=""></span>
                        </li>
                    </div>

                    <div>
                        <div class="sub-menu" *ngIf="subprocuremenu">
                            <li class="pointer" [routerLink]="['/admin/procure']" routerLinkActive="active">
                                <span class="list-icon"><img class="" src="assets/svg/machine-on-rent.svg" alt=""></span><span class="nav-text">Procure Listing</span>
                            </li>
                        </div>
                    </div> -->

                    <!-- <li class="pointer">
                        <span class="list-icon"><img class="" src="assets/svg/machine-on-rent.svg" alt=""></span><span class="nav-text">Machine-on-rent</span>
                    </li>

                    <li class="pointer">
                        <span class="list-icon"><img class="" src="assets/svg/Website.svg" alt=""></span><span class="nav-text">Website</span>
                    </li>

                    <li class="pointer">
                        <span class="list-icon"><img class="" src="assets/svg/tickets.svg" alt=""></span><span class="nav-text">Tickets</span>
                    </li> -->


                </ul>
            </div>

        </div>
        <div class="nav-data">
            <div class="logo col-md-10">
                <img [routerLink]="['/admin/dashboard']" class="pointer" [src]="getAssetLink('assets/svg/truventor-logo.svg')"
                    alt="truventor">
                <h4 class="head" *ngIf="isRMS">Manufacturing Partner Portal</h4>
                <h4 class="head" *ngIf="!isRMS">Raw Material Supplier</h4>
            </div>
            <div class="top-right">
                <div class="dropdown notification">
                    <a class="dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown"
                        aria-expanded="false">
                        <i class="fa fa-bell-o" aria-hidden="true"></i>
                        <span class="badge">{{notificationCount}}</span>
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                        <div class="mb-1">
                            <h2 *ngIf="notificationDetails.length != 0">Notification</h2>
                            <h2 *ngIf="notificationDetails.length == 0">No Notification Found</h2>
                            <button type="button" class="mr-3 mb-1 close mt-2" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <ul *ngFor="let item of notificationDetails">
                            <li>
                                <a class="">{{item?.rawMessage}}</a>
                            </li>
                            <!-- <li>
                        <a class="" href="#">Watson has placed an order <span>12-10-2020 8:20 AM</span> </a>
                    </li>
                    <li>
                        <a class="" href="#">Mark has joined the system as partner <span>12-10-2020 8:00 AM</span></a>
                    </li> -->
                        </ul>
                        <a class="clsview" *ngIf="notificationDetails.length != 0" (click)="viewAllNotification()">View
                            All</a>
                    </div>

                </div>
            </div>
            <div class="profile mt-3 cold-md-2" *ngIf="no_avatar" [matMenuTriggerFor]="menu">
                <img class="avatar pointer" [src]="avatar_url" alt="">
                <div class="data pointer">
                    <h6 class="name pointer">{{name}}</h6>
                    <span class="pointer">Active &nbsp;&nbsp;<img class="pointer" src="assets/svg/down-arrow.svg"
                            alt=""></span>
                    <mat-menu #menu="matMenu">
                        <button class="medium" mat-menu-item (click)="myProfile()">My Profile</button>
                        <button class="medium" (click)="logout()" mat-menu-item>Logout</button>
                    </mat-menu>
                </div>
            </div>
            <div class="profile mt-3 cold-md-2" *ngIf="!no_avatar" [matMenuTriggerFor]="menu">
                <p class="mb-0 name-avatar">{{first_name}}</p>
                <div class="data pointer">
                    <h6 class="name pointer">{{name}}</h6>
                    <span class="pointer">Active &nbsp;&nbsp;<img class="pointer" src="assets/svg/down-arrow.svg"
                            alt=""></span>
                    <mat-menu #menu="matMenu">
                        <button class="medium" mat-menu-item (click)="myProfile()">My Profile</button>
                        <button class="medium" (click)="logout()" mat-menu-item>Logout</button>
                    </mat-menu>
                </div>
            </div>
        </div>
        <router-outlet></router-outlet>
    </div>
</div>